import useSWR from 'swr'
import {useToken} from "../../../../app/hooks";
import API from "../../../../utils/api";
import {useEffect} from "react";


const M_KEY = '/user/deposit'

const fetchKey = () =>
	`${M_KEY}`;

export function useDepositInfo() {
	const { data: token } = useToken();

	const KEY = fetchKey();


	const fetcher = () => fetchAPI(KEY, token);
	const { data, mutate } = useSWR(token ? `${KEY}` : null, fetcher, { revalidateOnFocus: true });

	return { depositInfo: data, mutateDepositInfo: mutate};
}

async function fetchAPI(KEY:string, token:any)  {
	try {
		const response = await API.get(`${KEY}`, token + '', {});
		return response.result?.result;
	} catch (error) {
		console.error('Failed to fetch Deposit Info:', error);
		return { list: [], total: 0 };
	}
}